import { defineMessages } from "react-intl";

export const cancelOrderDialogMessages = defineMessages({
  dialogTitle: {
    id: "wmeRVH",
    defaultMessage: "Cancel order #{orderNumber}",
    description: "dialog header",
  },
  dialogContent: {
    id: "NWA+MK",
    defaultMessage:
      "<b>Important:</b> Refunds need to be issued <b>manually</b> after order cancelation.",
    description: "dialog content",
  },
  dialogContentAfterRefund: {
    id: "Co9VDy",
    defaultMessage: "<b>Refund successful.</b> You can now cancel the order.",
    description: "dialog content, shown after a refund was confirmed by the payment provider",
  },
  dialogContentAfterPendingRefund: {
    id: "o7FqlT",
    defaultMessage:
      "<b>Refund requested.</b> It hasn't been confirmed by the payment provider yet, but you can still cancel the order.",
    description: "dialog content, shown after a refund was requested but not yet confirmed",
  },
  buttonKeepOrder: {
    id: "p6ugX0",
    defaultMessage: "Keep order",
    description: "button to keep order",
  },
  buttonCancelOrder: {
    id: "bKTEnb",
    defaultMessage: "Cancel order",
    description: "button to cancel order",
  },
  reasonLabel: {
    id: "CZgHJ9",
    defaultMessage: "Reason for cancellation",
    description: "order cancel dialog, reason select label",
  },
  reasonHint: {
    id: "0E8E42",
    defaultMessage:
      "The reason is saved on the order and included in the cancellation email sent to the customer.",
    description: "order cancel dialog, reason hint",
  },
  otherReasonLabel: {
    id: "dyMs3R",
    defaultMessage: "Details",
    description: "order cancel dialog, free-text reason label",
  },
  reasonWrongPart: {
    id: "jYIXVQ",
    defaultMessage: "Ordered the wrong part",
    description: "order cancel reason",
  },
  reasonBetterPrice: {
    id: "+monPA",
    defaultMessage: "Found a better price",
    description: "order cancel reason",
  },
  reasonNoLongerNeeded: {
    id: "MaQDsz",
    defaultMessage: "No longer needed",
    description: "order cancel reason",
  },
  reasonDeliveryTooSlow: {
    id: "d3IBHJ",
    defaultMessage: "Delivery too slow",
    description: "order cancel reason",
  },
  reasonChangedVehicle: {
    id: "pA1Feb",
    defaultMessage: "Changed vehicle",
    description: "order cancel reason",
  },
  reasonOther: {
    id: "Y4ABuL",
    defaultMessage: "Other",
    description: "order cancel reason, free text",
  },
});
